// api.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class PasswordService {

  private apiUrl = `${environment.serverUrl}/api/`;

  constructor(private http: HttpClient) { }

  sendReset(email: string) { return this.http.post('/api/iam/users/reset', { email }); }
  
  resetPasswordConfirm(
  userId: string,
  resetCode: string,
  password: string
) {
  return this.http.post('/api/iam/users/reset/confirm', {
    userId,
    resetCode,
    password
  });
}


}
